var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillBlobLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214.986,
    height: 595.426,
    viewBox: "0 0 214.986 595.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 0.483,
    y1: 0.172,
    x2: 0.428,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0057",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5bf00",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.636,113.987c3.825-22.124,35.59-22.124,39.415,0L200.64,568.536a20,20,0,0,1-19.708,23.407H23.755A20,20,0,0,1,4.047,568.536Z",
    transform: "matrix(1, 0.017, -0.017, 1, 10.331, 0)",
    fill: "url(#y)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillBlobLg);
export default __webpack_public_path__ + "static/media/skill-blob-lg.aae90eb5478915f2433cf4ca0317e223.svg";
export { ForwardRef as ReactComponent };